export const productCategory = {
  notFound: {
    title: 'Catégorie Non Trouvée',
    returnToProducts: 'Retour aux Produits',
  },
  breadcrumb: {
    products: 'Produits',
  },
  backButton: 'Retour aux Produits',
  productsCount: {
    singular: 'Produit',
    plural: 'Produits',
  },
  productCard: {
    viewDetails: 'Voir les Détails',
  },
  cta: {
    title: 'Besoin d\'Aide pour Choisir le Bon Produit ?',
    subtitle: 'Nos experts techniques sont prêts à vous aider à trouver la solution de filtration parfaite pour vos besoins industriels spécifiques.',
    requestStudy: 'Demander une Étude Technique',
    contactTeam: 'Contacter Notre Équipe',
  },
};